import React, { useEffect, useContext, useState } from 'react';
import axiosConfig from '../../../utils/axiosConfig';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from "@fullcalendar/interaction";
import { Box, Grid, Paper } from '@material-ui/core';

import ResponsiveLayout from '../../Layouts/ResponsiveLayout';
import './Calendar.css';

import { StateContext, DispatchContext } from '../../../context/Provider';

const Calendar = (props) => {

    // demo => https://codesandbox.io/s/github/fullcalendar/fullcalendar-example-projects/tree/master/react?file=/src/DemoApp.jsx:3246-3255
    const appState = useContext(StateContext);
    const appDispatch = useContext(DispatchContext);
    const { authState } = appState;
    const { globalDispatch } = appDispatch;

    const [classworks, setClassworks] = useState([]);

    const handleDateClick = (arg) => {
        // console.log(arg);
    }
    
    const handleEventClick = (clickInfo) => {
        const { classcode } = clickInfo.event.extendedProps;
        const { id } = clickInfo.event;

        if (authState.user.role_id === 5) {
            props.history.push(`/${classcode}/classwork/${id}`);
        } else {
            props.history.push(`/${classcode}/classworkSubmissions/${id}`);
            // props.history.push(`/${classcode}/classwork`);
        }
    }

    async function fetchClassworks() {

        try {

            const response = await axiosConfig.get(`/studentClassworks`); 
            const { data } = response.data;
            const classworksArr = [];

            data.map(function (data, index) {
                classworksArr.push({
                    id: data.id,
                    title: data.formatted_title,
                    date: data.formatted_due_date,
                    color: data.theme_color || '#3788D8',
                    classcode: data.class_code
                });
            });

            setClassworks(classworksArr);
            
        } catch(e) {
            console.log(e);
        }

        globalDispatch({type: 'setIsLoading', value: false});
    }

    useEffect(() => {

        globalDispatch({type: 'setIsLoading', value: true});
        globalDispatch({type: 'setShowTabs', value: false});
        setTimeout(() => globalDispatch({type: 'setIsLoading', value: false}), 500);

        const source = axiosConfig.CancelToken.source();
        fetchClassworks();
        return () => {
            source.cancel();
        }

    }, []);

    return (
        <ResponsiveLayout>
            <Grid 
                container 
                spacing={2}
                justify="center"
            >
                <Grid item xs={12} sm={12} md={12} lg={10} xl={10}>
                    <Paper elevation={1}>
                        <Box p={2}>
                            <FullCalendar 
                                dateClick={handleDateClick}
                                eventClick={handleEventClick}
                                defaultView="dayGridMonth" 
                                plugins={[ dayGridPlugin, interactionPlugin ]} 
                                weekends={true}
                                events={classworks}
                            />
                        </Box>
                    </Paper>
                </Grid>
            </Grid>
        </ResponsiveLayout>
    );
}

export default Calendar;